module.exports = __webpack_public_path__ + "static/media/body-shape.b2b64b23.png";